import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import OpenPackModal from '../modals/OpenPackModal';
import QuestionModal from '../modals/QuestionModal';
import { getAssetImage } from '../util/util';
import '../elements/InventoryCard.css'
import { Database } from '../../server/database';
import ViewAssetModal from '../modals/ViewAssetModal';

interface InventoryCardProps {
  metadata: any;
  onUpdate: Function;
}

interface InventoryCardState {
  navigate: string;
  viewAsset: string;
}

class InventoryCard extends React.Component<InventoryCardProps, InventoryCardState> {
  constructor(props: InventoryCardProps) {
    super(props);

    this.state = {
      navigate: '',
      viewAsset: ''
    }
  }

  onCardClick() {
    this.setState({viewAsset: this.props.metadata.id});
  }

  onCloseViewAsset() {
    this.setState({viewAsset: ''});
    this.props.onUpdate();
  }

  render() {
    if(this.state.navigate) 
      return <Navigate to={this.state.navigate} />;

    let data = this.props.metadata;
    let imageClass = (data.category == 'banner') ? 'inventory-card-image-banner' : 'inventory-card-image';

    return (
      <div className="inventory-card">
        <div className="inventory-card-header" onClick={()=>this.onCardClick()}>
          <div className="inventory-card-header-name">{data.name}</div>
        </div>

        <div className="inventory-card-image-container" onClick={()=>this.onCardClick()}>
          <img className={imageClass} src={getAssetImage(data)} alt=''></img>
          {data.quantity > 1 &&
            <div className="inventory-card-data-count">x{data.quantity}</div>
          }
        </div>

        <div className="inventory-card-footer">
        </div>

        <ViewAssetModal asset={this.state.viewAsset} onClose={()=>this.onCloseViewAsset()} />
      </div>
    );
  }
}

export default InventoryCard;
